import { useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { sendKioskQrToEmail } from 'api/Kiosk';

import { verifyEmail } from 'lib/helpers/utility';
import { EMAIL_INVALID } from 'lib/constants/messages';
import { useCustomMutation } from 'lib/hooks/useCustomMutation';

import Input from 'components/shared/Input/Input';
import Modal from 'components/shared/Modal/Modal';

const CustomEmailModal = ({ open, handleClose }) => {
  const { practice } = useOutletContext();
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (verifyEmail(email)) {
      await sendQrToEmail(email);
      setEmail('');
      setError(null);
      handleClose();
    } else {
      setError(EMAIL_INVALID);
    }
  };

  const { mutateAsync: sendQrToEmail, isPending } = useCustomMutation({
    mutationFn: (customEmail) => {
      return sendKioskQrToEmail(navigate, { practiceId: practice?.id, email: customEmail });
    },
    successMessage: 'Kiosk QR code sent'
  });

  return (
    <Modal
      title="Custom email address"
      isCentered
      handleClose={handleClose}
      footerActions={{
        primary: { text: 'Send', onClick: handleSubmit, loading: isPending, isDisabled: isPending }
      }}
      isOpen={open}>
      <Input
        error={error}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        label="Email address"
        placeholder="example@mail.com"
      />
    </Modal>
  );
};

export default CustomEmailModal;
